import { ConstructionSiteFullDetails, PAGES } from "@dune/types";
import { Button, Tabs, TabsContent, TabsList, TabsTrigger } from "@dune/ui";
import { ClipboardList } from "lucide-react";
import { useState } from "react";
import { FormProvider } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useMe } from "../../../../api/queries/users.queries";
import { useConstructionSiteDetailsForm } from "../../../../component/brokers/constructionSites/useConstructionSiteDetailsForm";
import ConstructionSiteDetailsForm from "../../ConstructionSiteDetailsForm";
import { SubmissionOperation } from "../../submission/SubmissionOperation";
import { ReceptionOperation } from "../../receptionAnalysis/ReceptionOperation";
import { RoleEnum } from "../../../../../../../packages/vars/src";

interface OperationTabProps {
	constructionSite: ConstructionSiteFullDetails;
}

export const OperationTab: React.FC<OperationTabProps> = ({
	constructionSite,
}) => {
	const navigate = useNavigate();
	const [activeTab, setActiveTab] = useState<"souscription" | "reception">(
		"souscription",
	);
	const { form } = useConstructionSiteDetailsForm(constructionSite);
	const { me: user } = useMe();
	const isInsurer = user?.role === RoleEnum.INSURER;
	const isDune = user?.role === RoleEnum.DUNE;
	const statusAllowsEdit =
		constructionSite.status === "NEW" ||
		constructionSite.status === "IN_PROGRESS" ||
		constructionSite.status === "TO_ANALYZE";
	const handleTabChange = (value: string) => {
		if (value === "souscription" || value === "reception") {
			setActiveTab(value);
		}
	};
	return (
		<FormProvider {...form}>
			<div className="flex justify-between items-center">
				<div className="text-blue-badge-text text-2xl font-semibold">
					Opération
				</div>
				{(isDune ||
					(statusAllowsEdit && !isInsurer && !constructionSite.isSkipped)) && (
					<Button
						type="button"
						onClick={() =>
							navigate(
								PAGES.PROJECTS.edit.withParams(
									constructionSite.id.toString(),
									2,
								),
							)
						}
					>
						Modifier l'opération
					</Button>
				)}
			</div>

			<Tabs
				value={activeTab}
				onValueChange={handleTabChange}
				className="w-full"
			>
				<TabsList>
					<TabsTrigger value="souscription" variant="compact">
						Souscription
					</TabsTrigger>
					<TabsTrigger value="reception" variant="compact">
						Réception
					</TabsTrigger>
				</TabsList>

				<TabsContent value="souscription" className="mt-4">
					{constructionSite.status === "NEW" ? (
						<ConstructionSiteDetailsForm isForm={false} />
					) : (
						<SubmissionOperation
							hideTitle
							disabledInputs
							disabledDocuments={!isDune}
						/>
					)}
				</TabsContent>
				<TabsContent value="reception" className="mt-4">
					{constructionSite.constructionSiteDetails?.receptionDate ? (
						<ReceptionOperation />
					) : (
						<div className="text-center py-8">
							<ClipboardList className="h-16 w-16 text-gray-400 mx-auto mb-4" />
							<h3 className="text-lg font-semibold text-gray-600 mb-2">
								Aucune donnée de réception disponible
							</h3>
							<p className="text-gray-500 mb-4">
								Les informations de réception seront affichées après
								l'ouverture.
							</p>
						</div>
					)}
				</TabsContent>
			</Tabs>
		</FormProvider>
	);
};
